import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const PROOF_ITEMS = [
  { src: 'https://4kdreamers.com/7-Copie.webp', label: 'Client USA – Paid via PayPal' },
  { src: 'https://4kdreamers.com/4.webp', label: 'Client USA – Paid via PayPal' },
  { src: 'https://4kdreamers.com/5.webp', label: 'Client USA – Paid via PayPal' },
];

export default function SocialProof() {
  const { t } = useTranslation();
  const [current, setCurrent] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const total = PROOF_ITEMS.length;
  const next = () => setCurrent(c => (c + 1) % total);
  const prev = () => setCurrent(c => (c - 1 + total) % total);

  useEffect(() => {
    intervalRef.current = setInterval(next, 3500);
    return () => { if (intervalRef.current) clearInterval(intervalRef.current); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getVisible = () => [PROOF_ITEMS[(current) % total], PROOF_ITEMS[(current + 1) % total], PROOF_ITEMS[(current + 2) % total]];

  return (
    <section className="py-12 sm:py-16 md:py-20 bg-gray-950 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute top-1/3 left-1/4 w-80 h-80 bg-emerald-500 rounded-full blur-[120px]" />
        <div className="absolute bottom-1/3 right-1/4 w-80 h-80 bg-cyan-500 rounded-full blur-[120px]" />
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-10 sm:mb-14">
          <div className="inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/20 rounded-full px-4 py-2 mb-4 sm:mb-6">
            <span className="text-sm font-medium text-emerald-400">{t('social.badge')}</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-white mb-3 sm:mb-4 tracking-tight">
            {t('social.title1')} <span className="text-emerald-400">{t('social.title2')}</span>
          </h2>
          <p className="text-gray-400 text-base sm:text-lg max-w-2xl mx-auto">{t('social.desc')}</p>
        </div>
        <div className="max-w-5xl mx-auto relative">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {getVisible().map((item, idx) => (
              <div key={idx} className="group relative rounded-2xl overflow-hidden border border-white/10 hover:border-emerald-500/40 transition-all duration-300 bg-gray-900/60">
                <div className="aspect-[9/16] overflow-hidden">
                  <img src={item.src} alt={item.label} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent p-4">
                  <span className="text-xs sm:text-sm text-white font-medium truncate block">{item.label}</span>
                  <div className="flex gap-0.5 mt-1.5">{[1,2,3,4,5].map(s => <i key={s} className="ri-star-fill text-amber-400 text-xs" />)}</div>
                </div>
              </div>
            ))}
          </div>
          <button onClick={prev} className="hidden sm:flex absolute -left-5 top-1/2 -translate-y-1/2 w-10 h-10 bg-gray-800/80 border border-white/10 text-white rounded-full items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer"><i className="ri-arrow-left-s-line text-xl" /></button>
          <button onClick={next} className="hidden sm:flex absolute -right-5 top-1/2 -translate-y-1/2 w-10 h-10 bg-gray-800/80 border border-white/10 text-white rounded-full items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer"><i className="ri-arrow-right-s-line text-xl" /></button>
        </div>
        <div className="mt-12 sm:mt-16 flex flex-wrap justify-center gap-8 sm:gap-12">
          {(['1','2','3'] as const).map(n => (
            <div key={n} className="text-center">
              <div className="text-3xl sm:text-4xl font-black text-emerald-400">{t(`social.stat${n}_val`)}</div>
              <div className="text-sm text-gray-500">{t(`social.stat${n}_label`)}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
